<template>
  <div
    v-if="visible"
    :class="modalClass"
    :style="{ top: `${position?.top}px`, left: `${position?.left}px` }"
  >
    <h2
      v-if="statusType"
      class="text-xl font-bold mb-5 text-neutral-gray-80 dark:text-text-primary-dark"
    >
      {{
        statusType === "Aprobado"
          ? "Corrección Aprobada"
          : statusType === "Rechazado"
            ? "Corrección Rechazada"
            : statusType === "Devolución"
              ? "Corrección con Devolución"
              : ""
      }}
    </h2>
    <!-- Subtítulo -->
    <h3
      class="text-sm font-bold mb-2 text-neutral-gray-80 dark:text-text-primary-dark"
    >
      {{ header }}
    </h3>
    <MainTable
      :items="data"
      :columns="columns"
      :requiredArrow="false"
      :isLastColumnColor="isLastColumnColor"
      :colorLastColumn="colorLastColumn"
      headerClass="!text-[10px] font-700 text-text-title dark:!text-text-primary-dark font-400 !border-b-[1px] !border-border-default"
      rowClass="!text-[10px] font-400 text-text-title dark:!text-text-primary-dark"
      class="text-text-title dark:text-text-primary-dark"
    >
      <template #amount="{ data, index }">
        <span
          class="text-[10px] text-text-title dark:text-text-primary-dark"
          :class="{
            [colorLastColumn]: isLastColumnColor && isLastRow(data),
          }"
        >
          {{
            index > 0 && data.amount === props.data[index - 1]?.amount
              ? "-"
              : operationType.money === "CLP"
                ? formatPrice(data.amount, "$")
                : formatPrice(data.amount, "$", 2)
          }}
        </span>
      </template>

      <template #bankCrediCorp="{ data, index }">
        <span
          class="text-[10px] text-text-title dark:text-text-primary-dark"
          :class="{
            [colorLastColumn]: isLastColumnColor && isLastRow(data),
          }"
        >
          {{
            index > 0 &&
            data.bankCrediCorp?.description ===
              props.data[index - 1]?.bankCrediCorp?.description
              ? "-"
              : data.bankCrediCorp?.description || "-"
          }}
        </span>
      </template>
      <template #credicorpAccount="{ data, index }">
        <span
          class="text-[10px] text-text-title dark:text-text-primary-dark"
          :class="{
            [colorLastColumn]: isLastColumnColor && isLastRow(data),
          }"
        >
          {{
            index > 0 &&
            data.bankCrediCorp?.accountNumber ===
              props.data[index - 1]?.bankCrediCorp?.accountNumber
              ? "-"
              : data.bankCrediCorp?.accountNumber || "-"
          }}
        </span>
      </template>
    </MainTable>

    <!-- Observación -->
    <div
      v-if="observationSupervisor"
      class="mt-6 text-neutral-gray-80 dark:text-text-primary-dark"
    >
      <p class="text-sm font-bold mb-1">Observación</p>
      <p class="text-sm font-normal italic">{{ observationSupervisor }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import MainTable from "../ui/MainTable.vue";
import { useCurrencyFormatter } from "../../composables/useFormatPrice";
import { TransactionSelectItem } from "@/types/operations";
import { PropType } from "vue";

interface BankCrediCorp {
  description?: string;
  accountNumber?: string;
}

interface OperationData {
  correctionDate?: string;
  amount?: number;
  bankCrediCorp?: BankCrediCorp;
  analistName?: string;
  supervisorName?: string;
  [key: string]: any;
}

const props = defineProps({
  data: {
    type: Array as () => OperationData[],
    default: () => [],
  },
  visible: {
    type: Boolean,
    default: false,
  },
  header: {
    type: String,
    default: "",
  },
  position: {
    type: Object,
    required: false,
  },
  observationSupervisor: {
    type: String,
    default: null,
  },
  statusType: {
    type: String,
    default: "",
  },
  modalClass: {
    type: String,
    default:
      "absolute z-50 bg-white border border-gray-300 shadow-md rounded-lg p-5  dark:bg-surface-primary !dark:text-text-primary-dark",
  },
  isAbono: {
    type: Boolean,
    default: false,
  },
  isLastColumnColor: {
    type: Boolean,
    default: false,
  },
  colorLastColumn: {
    type: String,
    default: "",
  },
  operationType: {
    type: Object as PropType<TransactionSelectItem>,
    default: 1,
  },
});
const { formatPrice } = useCurrencyFormatter();

const columns = [
  {
    field: "correctionDate",
    header: "Fecha Corrección",
    style: "width: 110px",
  },
  { field: "amount", header: "Monto", style: "width: 90px" },
  { field: "bankCrediCorp", header: "Banco Credicorp", style: "width: 90px" },
  {
    field: "credicorpAccount",
    header: "Número de cuenta",
    style: "width: 90px",
  },
  { field: "analistName", header: "Analista", style: "width: 90px" },
  { field: "supervisorName", header: "Supervisor", style: "width: 90px" },
];

const isLastRow = (rowData: any) => {
  const lastItem = props.data?.[props.data.length - 1];
  return JSON.stringify(rowData) === JSON.stringify(lastItem);
};
</script>
